/** One titled block of the partner page (outlined paper, heading, optional actions). */
import { Box, Paper, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function Section({ title, actions, children }: { title: string; actions?: ReactNode; children: ReactNode }) {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5, gap: 1 }}>
        <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 700, flexGrow: 1 }}>
          {title}
        </Typography>
        {actions}
      </Box>
      {children}
    </Paper>
  );
}
